import { type FC } from 'react'

import {
  type OfferV11,
  type PimProductWithVariantsV1,
} from '@redteclab/api/clients/bully'
import { type SellerPromotionV2 } from '@redteclab/api/clients/composition-service-transactions'
import { IconInfo } from '@redteclab/icons'

import { useOpenableControls } from '../../../../generic-hooks'
import {
  ProductHeadGenericLabel,
  ProductSellerPromotionFlag,
} from '../../../../product'

import { ProductBuyBoxSellerPromotionModal } from './ProductBuyBoxSellerPromotionModal'

export const ProductBuyBoxSellerPromotionBadge: FC<{
  offer: OfferV11
  product: PimProductWithVariantsV1
  sellerPromotion: SellerPromotionV2
}> = ({ offer, product, sellerPromotion }) => {
  const { handleClose, handleOpen, isOpen } = useOpenableControls()

  return (
    <>
      <ProductHeadGenericLabel
        className="border-light-primary-strong bg-light-tertiary"
        data-qa-id="product-label-seller-promotion"
        onClick={() => {
          handleOpen()
        }}
      >
        <ProductSellerPromotionFlag sellerPromotion={sellerPromotion} />
        <IconInfo className="ml-1 size-4 shrink-0" />
      </ProductHeadGenericLabel>
      <ProductBuyBoxSellerPromotionModal
        dialogTitle={
          <ProductSellerPromotionFlag sellerPromotion={sellerPromotion} />
        }
        isOpen={isOpen}
        offer={offer}
        onClose={handleClose}
        product={product}
      />
    </>
  )
}
